import type { FaireProductEntity } from "../../entity_types/product";

export const p_p8gryyqreu: FaireProductEntity = {
  token: "p_p8gryyqreu",
  type: "product",
  name: "Cozy cat and books at home mug",
  brandToken: "b_qpb3ygknfs",
  brandName: "Divine Vessels Pottery",
  imageUrl:
    "https://cdn.faire.com/fastly/f3174753104d798872796f95981c0229cf437f8c7ea68cdd3e97aa0620cde689.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/53ca6daa88b61d56314a93c7152a9bf703c5ac46204e70c2606ba2d6d20df75f.jpeg",
    "https://cdn.faire.com/fastly/f91a0577c028a97a040b28ae7e8481969e48b033ef6a2b896be32d4b6844c778.jpeg",
    "https://cdn.faire.com/fastly/24e480b5c8cd69d3f14620f116e24e09db682030b01ca453b2daea479a30fe7f.jpeg",
    "https://cdn.faire.com/fastly/e8ce5efe38c8ed67e366b5d1abfc0bbe7546e31720c31c463ac9f813f51c23af.jpeg",
    "https://cdn.faire.com/fastly/a7f459218c99ae89040662feac3a29594c11d0fd80b6f5f31b06727fa2c7b98c.jpeg",
    "https://cdn.faire.com/fastly/2097b986c72994e0ba67c08fb5c0feb24207aeb2a5122fe4a8b398108e60f0b4.jpeg",
    "https://cdn.faire.com/fastly/688eba2c9bdbf21f2088903d93ea5bf9abeb4d95668749bac182b2765dd94a3b.jpeg",
    "https://cdn.faire.com/fastly/7583e4cb605316b10103d6734957d06dab80de7b2f9b488c723963ba0a5b6188.png",
    "https://cdn.faire.com/fastly/0a5978674b36bec35e1458cce37bfd8d813f20f956ba85d30a2f44ac57bd7bcf.png",
    "https://cdn.faire.com/fastly/5002b7749ab69cbde971a4f4d0ac7d134997f6ed55d8df17834f51debc0d9c14.jpeg",
  ],
  priceDollars: 27.71,
  description:
    "This expertly crafted mug features a charming scene of a cozy cat nestled among books, all highlighted by a soothing blue glaze. Pride and prejudice book waiting for you to read curled up with your cat. Perfect for book lovers and cat enthusiasts alike, it offers a comforting touch to your daily coffee or tea ritual while adding a subtle quant flair to your kitchenware collection.\n\n* Holds 20 oz. \n* Handmade in the USA\n* Woman owned business \n* Each piece is carefully handcrafted by the artist so there are slight variations from the                      item pictured. \n*This is stoneware pottery known for its rugged qualities\n* Dishwasher, microwave and oven safe. ",
  tags: [],
  msrpDollars: 52.66,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:50:05.407Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
